// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: transport/transport_connection_timeout_reason.proto

/* eslint-disable */

export const protobufPackage = "transport";

export enum TransportConnectionTimeoutReason {
  TRANSPORT_CONNECTION_TIMEOUT_REASON_UNSPECIFIED = 0,
  TRANSPORT_CONNECTION_TIMEOUT_REASON_DTLS = 1,
  TRANSPORT_CONNECTION_TIMEOUT_REASON_ICE = 2,
  UNRECOGNIZED = -1,
}

export function transportConnectionTimeoutReasonFromJSON(object: any): TransportConnectionTimeoutReason {
  switch (object) {
    case 0:
    case "TRANSPORT_CONNECTION_TIMEOUT_REASON_UNSPECIFIED":
      return TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_UNSPECIFIED;
    case 1:
    case "TRANSPORT_CONNECTION_TIMEOUT_REASON_DTLS":
      return TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_DTLS;
    case 2:
    case "TRANSPORT_CONNECTION_TIMEOUT_REASON_ICE":
      return TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_ICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransportConnectionTimeoutReason.UNRECOGNIZED;
  }
}

export function transportConnectionTimeoutReasonToJSON(object: TransportConnectionTimeoutReason): string {
  switch (object) {
    case TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_UNSPECIFIED:
      return "TRANSPORT_CONNECTION_TIMEOUT_REASON_UNSPECIFIED";
    case TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_DTLS:
      return "TRANSPORT_CONNECTION_TIMEOUT_REASON_DTLS";
    case TransportConnectionTimeoutReason.TRANSPORT_CONNECTION_TIMEOUT_REASON_ICE:
      return "TRANSPORT_CONNECTION_TIMEOUT_REASON_ICE";
    case TransportConnectionTimeoutReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
